import React from "react";
import { List, ListItem, Typography } from "@mui/material";
import PendingCreditRequestCard from "./PendingCreditRequestCard";
import { creditStatus } from "../../util/creditRequestMapping";
import { useStyles } from "../ReceiveList/Receive.styles";
import { PendingCreditRequestListProps } from "./types";
export default function PendingCreditRequestList(props: PendingCreditRequestListProps) {
	const { creditRequests, status, onView } = props;
	const classes = useStyles();

	return (
		<React.Fragment>
			{status === creditStatus.pendingReview && <Typography className={classes.statusTitle}>Pending Review</Typography>}
			{status === creditStatus.reviewing && <Typography className={classes.statusTitle}>Reviewing</Typography>}
			{status === creditStatus.awaitingSupplier && (
				<Typography className={classes.statusTitle}>Awaiting Supplier</Typography>
			)}
			<Typography variant="body1" display="inline">
				{creditRequests.length} credit request{creditRequests.length > 1 && "s"} waiting
				{status === creditStatus.pendingReview && " to be reviewed"}
				{status === creditStatus.inProgress && " to be claimed"}
			</Typography>
			<List className={classes.creditRequestRootContainer}>
				{creditRequests.map((creditRequest) => {
					const uniqueReasons = Array.from(
						new Set(
							creditRequest.lineItems
								.filter((lineItem) => lineItem.status === status)
								.map((lineItem) => lineItem.reason)
						)
					);
					const reasons = uniqueReasons.join(", ");
					return (
						<ListItem key={creditRequest.id} className={classes.creditRequestListItem}>
							<PendingCreditRequestCard {...creditRequest} onView={onView} reason={reasons} lineStatus={status} />
						</ListItem>
					);
				})}
			</List>
		</React.Fragment>
	);
}
